import { NgModule } from '@angular/core';

import { KeysPipe } from './keys.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { FilterPipe } from './filter.pipe';
import { CamelCaseToDashPipe } from './camelCaseToDash.pipe';
import { CurrencyPipe } from './currency.pipe';
import { RolePermissionsPipe } from './role-permissions.pipe';
import { DrpSearchPipe } from './drp-search.pipe';
import { mySameDate } from './sameDate.pipe';

@NgModule({
    declarations: [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        mySameDate,
        FilterPipe,
        CamelCaseToDashPipe,
        CurrencyPipe,
        RolePermissionsPipe,
        DrpSearchPipe
    ],
    imports     : [],
    exports     : [
        KeysPipe,
        GetByIdPipe,
        HtmlToPlaintextPipe,
        mySameDate,
        FilterPipe,
        CamelCaseToDashPipe,
        CurrencyPipe,
        RolePermissionsPipe,
        DrpSearchPipe
    ]
})
export class FusePipesModule
{
}
